import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

/** Opção de campo de admissão digital (grupo) — independente de `RecruitmentCustomFieldItemOptionModel`. */
export class RecruitmentAdmissionCustomFieldItemOptionModel
  extends Model
  implements IModel<RecruitmentAdmissionCustomFieldItemOptionModel>
{
  public admissionCustomFieldItemId: string = '';
  public label: string = '';
  public legend: string = '';
  public order: number = 0;
  public isUpdate: boolean = false;

  static create(input: any): RecruitmentAdmissionCustomFieldItemOptionModel {
    return ObjectMapper.deserialize<RecruitmentAdmissionCustomFieldItemOptionModel>(
      RecruitmentAdmissionCustomFieldItemOptionModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
